export function requestEditor(window,command,args={}) {
  return new Promise((resolve,reject)=>{
    const id=window.crypto.randomUUID();
    const timer=window.setTimeout(()=>{cleanup();reject(new Error('Editor command timed out'));},42_000);
    const cleanup=()=>{window.clearTimeout(timer);window.removeEventListener('studio:editor-result',receive);};
    const receive=event=>{
      if(event.detail?.id!==id) return;
      cleanup();
      event.detail.error ? reject(new Error(event.detail.error)) : resolve(event.detail.result);
    };
    window.addEventListener('studio:editor-result',receive);
    window.dispatchEvent(new window.CustomEvent('studio:editor-command',{detail:{id,command,args}}));
  });
}

